export default __webpack_public_path__ + "static/media/robcan.f7eecedd.jpeg";